// @flow
import RemoveFavoriteTeamModalContent from 'components/fragments/modal/modalContents/RemoveFavoriteTeamModalContent';
import { connect } from 'react-redux';

import { postUserPref } from 'actions/userActions';
import type {
  DispatchProps,
  StateProps
} from 'components/fragments/modal/modalContents/RemoveFavoriteTeamModalContent';
import type { DispatchType, StateType } from 'types/Actions';
import type { EditProfileValueType } from 'types/User';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref
  }),
  (dispatch: DispatchType): DispatchProps => ({
    postUserPref: (action: string, id: EditProfileValueType, token: string) => dispatch(postUserPref(action, id, token))
  })
)(RemoveFavoriteTeamModalContent);
